export const COMPONENT_BASE_CLASS = 'lists';
